module.exports = __webpack_public_path__ + "img/no-keyword.d7c37b63.png";